import { cx } from '../lib/util.ts'

/** Cuisine plus up to two badge tags, styled by what they mean. */
export function RecipeTags({ cuisine, tags, onDark }: { cuisine?: string; tags: string[]; onDark?: boolean }) {
  if (!cuisine && !tags.length) return null
  return (
    <div className="tagrow">
      {cuisine && <span className="cuisine">{cuisine}</span>}
      {tags.map((tag) => (
        <span key={tag} className={cx('tag', toneOf(tag))}>{label(tag)}</span>
      ))}
      {onDark && null}
    </div>
  )
}

const GREEN = new Set(['vegetarian', 'vegan', 'gluten-free', 'dairy-free'])
const WARM = new Set(['spicy', 'hot'])

const toneOf = (tag: string): string =>
  GREEN.has(tag) ? 'tag-accent-2' : WARM.has(tag) ? 'tag-accent' : 'tag-neutral'

const label = (tag: string): string => tag.charAt(0).toUpperCase() + tag.slice(1)
